/**
 * Constants set in the mobile integration state
 */

// Device-specific flags set within the iOS and Android environments
export const SYSTEM_DEVICE_PLATFORM_IOS = "MOBILE_IOS_WEB";
export const SYSTEM_DEVICE_PLATFORM_ANDROID = "MOBILE_ANDROID_WEB";
